import React, { memo, useCallback } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import PropTypes from "prop-types";

import {START_DATE_STR} from "@assets/constants/dates"

const DashboardDatePicker = memo(
  ({
    dates,
    dateCase = "start",
    openEnd,
    op,
    setOpenEnd,
    setOp,
    handleChangeDate,
  }) => {
    const viewValue = dateCase === "start" ? dates.start : dates.end;
    const viewMinDate = dateCase === "start" ? new Date(START_DATE_STR) : dates.start;
    const viewMaxDate = new Date();
    const viewOpen = dateCase === "start" ? op : openEnd;
    const handleOnOff = useCallback(
      (dateCase = "start", check = true) => {
        if (dateCase === "start") {
          setOp(check);
        } else {
          setOpenEnd(check);
        }
      },
      [setOp, setOpenEnd]
    );
    const handleClick = useCallback(
      (dateCase = "start") => {
        dateCase === "start" ? setOp(true) : setOpenEnd(true);
      },
      [setOp, setOpenEnd]
    );
    return (
      <Grid>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            inputFormat={"yyyy-MM-dd"}
            mask={"____-__-__"}
            value={viewValue}
            minDate={viewMinDate}
            maxDate={viewMaxDate}
            open={viewOpen}
            onOpen={() => handleOnOff(dateCase, true)}
            onClose={() => handleOnOff(dateCase, false)}
            disableOpenPicker
            margin="dense"
            onChange={(e) => handleChangeDate(e, dateCase)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                onClick={(e) => handleClick(dateCase)}
                fullWidth
                disabled
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "black",
                    fontSize: "1.4rem",
                  },
                  "& .MuiInputBase-root": {
                    maxWidth: "100px",
                    cursor: "pointer",
                    "&:hover": {
                      border: "none",
                    },
                    "&:before": {
                      border: "none",
                    },
                    border: "none",
                    m: 0,
                    fontSize: 12,
                    "& .MuiButtonBase-root": {
                      border: "none",
                    },
                    "& .MuiInputBase-input": {
                      padingRight: 1,
                      border: "none",
                      cursor: "pointer",
                    },
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
    );
  }
);

DashboardDatePicker.propTypes = {
  dates: PropTypes.object,
  dateCase: PropTypes.string,
  openEnd: PropTypes.bool,
  op: PropTypes.bool,
  setOpenEnd: PropTypes.func,
  setOp: PropTypes.func,
  handleChangeDate: PropTypes.func,
};

export default DashboardDatePicker;
